import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function getPlaceById(params) {
  return request({
    url: ENDPOINT.PLACE_PUBLIC,
    method: 'get',
    params
  })
}
